"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAbilityToCustomizePlan = exports.getScopeOfCoverage = exports.getPayVetDirectly = exports.getBottomLine = exports.getSubProductType = exports.getCanBuyOnlineAnnotation = exports.getCanBuyOnline = exports.getCategory = exports.getStarRatingTooltip = exports.getStarRating = exports.getProsBullets = exports.getPoliciesOfferedAnnotation = exports.getPoliciesOffered = exports.getNAICComplaintsAnnotation = exports.getNAICComplaints = exports.getLearnMoreLink = exports.getFinancialStrengthRatingAnnotation = exports.getFinancialStrengthRating = exports.getEaseOfUse = exports.getDiscounts = exports.getCoverageOptions = exports.getConsBullets = exports.getIssuerName = exports.getImageSrc = exports.getImageAltText = exports.getName = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _generalUtils = require("./common/general-utils");

var _utils = require("../utils");

/**
 * Get the name to display for an offer.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The offer name.
 */
var getName = function getName(marketplaceEntity) {
  return (0, _utils.getNameWithFallbacks)(marketplaceEntity);
};
/**
 * Gets the name of the entity as the alt text for the associated image.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @return     {string}                     The Alt text.
 */


exports.getName = getName;

var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getName(marketplaceEntity);
};
/**
 * Gets source URL of the image associated with the offer.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @return     {string}                     The URL of the image.
 */


exports.getImageAltText = getImageAltText;

var getImageSrc = function getImageSrc(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the issuer.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     Issuer name.
 */


exports.getImageSrc = getImageSrc;

var getIssuerName = function getIssuerName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'name');
};
/**
 * Gets the "cons" bullets
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {Array}  The "cons" array
 */


exports.getIssuerName = getIssuerName;

var getConsBullets = function getConsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.cons_bullets.value');
};
/**
 * Get the coverage options.
 *
 * @param      {Object} marketplaceEntity   The insurance entity
 *
 * @returns    {string}                     The coverage options
 */


exports.getConsBullets = getConsBullets;

var getCoverageOptions = function getCoverageOptions(marketplaceEntity) {
  var coverageOption = (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.coverage_options.value'); // TODO: Cleanup this stop-gap fix after the long-term fix (REVS-229/PP-5364) has been shipped

  if (coverageOption === 'Above average') {
    return 'About average';
  }

  return coverageOption;
};
/**
 * Gets the discounts.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @return     {string}                     The discounts.
 */


exports.getCoverageOptions = getCoverageOptions;

var getDiscounts = function getDiscounts(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.discounts.value');
};
/**
 * Gets the ease of use.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @return     {string}                     The ease of use.
 */


exports.getDiscounts = getDiscounts;

var getEaseOfUse = function getEaseOfUse(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.ease_of_use.value');
};
/**
 * Gets the financial strength rating.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The financial strength rating.
 */


exports.getEaseOfUse = getEaseOfUse;

var getFinancialStrengthRating = function getFinancialStrengthRating(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.financial_strength_rating.value');
};
/**
 * Gets the financial strength rating annotation.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The financial strength rating annotation.
 */


exports.getFinancialStrengthRating = getFinancialStrengthRating;

var getFinancialStrengthRatingAnnotation = function getFinancialStrengthRatingAnnotation(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.financial_strength_rating_annotation.value');
};
/**
 * Get URL of the review.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The URL of the review.
 */


exports.getFinancialStrengthRatingAnnotation = getFinancialStrengthRatingAnnotation;

var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.nw_review_url.value');
};
/**
 * Gets the amount of NAIC complaints.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The amount of NAIC complaints.
 */


exports.getLearnMoreLink = getLearnMoreLink;

var getNAICComplaints = function getNAICComplaints(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.naic_complaints.value');
};
/**
 * Gets the naic_complaints_annotation value for the entity.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @returns    {string}                     The annotation for the naic_complaints field.
 */


exports.getNAICComplaints = getNAICComplaints;

var getNAICComplaintsAnnotation = function getNAICComplaintsAnnotation(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.naic_complaints_annotation.value');
};
/**
 * Gets the policies offered.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity
 *
 * @return     {string}                     The string description of the policies offered.
 */


exports.getNAICComplaintsAnnotation = getNAICComplaintsAnnotation;

var getPoliciesOffered = function getPoliciesOffered(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.policies_offered.value');
};
/**
 * Gets the policies_offered_annotation value for the entity.
 * @param {Object} marketplaceEntity The insurance entity.
 * @returns {string}  The annotation for the policies_offered field.
 */


exports.getPoliciesOffered = getPoliciesOffered;

var getPoliciesOfferedAnnotation = function getPoliciesOfferedAnnotation(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.policies_offered_annotation.value');
};
/**
 * Gets the "pros" bullets
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {Array}  The "pros" array
 */


exports.getPoliciesOfferedAnnotation = getPoliciesOfferedAnnotation;

var getProsBullets = function getProsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.pros_bullets.value');
};
/**
 * Gets nw_rating value.
 *
 * @param      {Object}  marketplaceEntity  The insurance entity.
 *
 * @return     {number}                     The star rating.
 */


exports.getProsBullets = getProsBullets;

var getStarRating = function getStarRating(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.nw_rating.value');
};
/**
 * Gets the star rating tooltip.
 *
 * @return     {string}                     The star rating tooltip.
 */


exports.getStarRating = getStarRating;

var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account consumer complaint and customer satisfaction data.";
};
/**
 * Gets the category for the entity.
 * @param {Object} marketplaceEntity The insurance entity.
 * @returns {string} The category.
 */


exports.getStarRatingTooltip = getStarRatingTooltip;

var getCategory = function getCategory(marketplaceEntity) {
  var _getProduct, _getProduct$details, _getProduct$details$c;

  return (_getProduct = (0, _generalUtils.getProduct)(marketplaceEntity)) === null || _getProduct === void 0 ? void 0 : (_getProduct$details = _getProduct.details) === null || _getProduct$details === void 0 ? void 0 : (_getProduct$details$c = _getProduct$details.category) === null || _getProduct$details$c === void 0 ? void 0 : _getProduct$details$c.value;
};
/**
 * Gets the can_buy_online value for the entity.
 * @param {Object} marketplaceEntity The insurance entity.
 * @returns {boolean} Whether the insurance can be bought online.
 */


exports.getCategory = getCategory;

var getCanBuyOnline = function getCanBuyOnline(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.can_buy_online.value');
};
/**
 * Gets the can_buy_online_annotation value for the entity.
 * @param {Object} marketplaceEntity The insurance entity.
 * @returns {string} The annotation for the can_buy_online field.
 */


exports.getCanBuyOnline = getCanBuyOnline;

var getCanBuyOnlineAnnotation = function getCanBuyOnlineAnnotation(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.can_buy_online_annotation.value');
};
/**
 * Gets the sub product type.
 *
 * @param     {Object}  marketplaceEntity  The insurance entity.
 *
 * @return    {string}                     The sub product type.
 */


exports.getCanBuyOnlineAnnotation = getCanBuyOnlineAnnotation;

var getSubProductType = function getSubProductType(marketplaceEntity) {
  var _product$details, _product$details$sub_, _product$details2, _product$details2$cat;

  var product = (0, _generalUtils.getProduct)(marketplaceEntity);
  /*
   * According to the following link the category is now legacy so we should prioritize the sub product type.
   * @link {https://github.com/NerdWallet/marketplace/blob/f3644e98bbddd180b13d3de97116cb3cd6de07a2/src/schemas/insurance/product_details.json#L3}
   * However, to ensure that we have a value fallback to category because not all offers have sub product type set.
   */

  return (product === null || product === void 0 ? void 0 : (_product$details = product.details) === null || _product$details === void 0 ? void 0 : (_product$details$sub_ = _product$details.sub_product_type) === null || _product$details$sub_ === void 0 ? void 0 : _product$details$sub_.value) || (product === null || product === void 0 ? void 0 : (_product$details2 = product.details) === null || _product$details2 === void 0 ? void 0 : (_product$details2$cat = _product$details2.category) === null || _product$details2$cat === void 0 ? void 0 : _product$details2$cat.value);
};
/**
 * Gets the bottom line from the offer-level and fallback to the product-level.
 *
 * @param   {Object} marketplaceEntity  The insurance entity.
 *
 * @return  {string}                    Bottom line text.
 */


exports.getSubProductType = getSubProductType;

var getBottomLine = function getBottomLine(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.bottom_line_text.value') || (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.product_bottom_line_text.value');
};
/**
 * Gets whether it can be paid directly to the vet
 *
 * @param   {Object} marketplaceEntity  The insurance entity.
 *
 * @return  {string}                    Yes or No.
 */


exports.getBottomLine = getBottomLine;

var getPayVetDirectly = function getPayVetDirectly(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.pay_vet_directly.value') || (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.pay_vet_directly.value');
};
/**
 * Gets scope of coverage
 *
 * @param   {Object} marketplaceEntity  The insurance entity.
 *
 * @return  {string}                    Coverage scope.
 */


exports.getPayVetDirectly = getPayVetDirectly;

var getScopeOfCoverage = function getScopeOfCoverage(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.scope_of_coverage.value') || (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.scope_of_coverage.value');
};
/**
 * Gets the scope of plan customization
 *
 * @param   {Object} marketplaceEntity  The insurance entity.
 *
 * @return  {string}                    Scope of plan customization.
 */


exports.getScopeOfCoverage = getScopeOfCoverage;

var getAbilityToCustomizePlan = function getAbilityToCustomizePlan(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.ability_to_customize_plan.value') || (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.ability_to_customize_plan.value');
};

exports.getAbilityToCustomizePlan = getAbilityToCustomizePlan;